module.exports = __webpack_public_path__ + "static/user2-0efad70afd7b4ef410bd714505ad22a3.png";